module.exports = __webpack_public_path__ + "img/sy.f5a37f0e.jpg";